<div class="sign-out-page min-h-50 text-white">
    <div class="slider-bg-img gradient01 ">
        <div class="container">
            <nav class="py-4">
                <ol itemscope itemtype="http://schema.org/BreadcrumbList" class="breadcrumb breadcrumb-arrow breadcrumb-tdm mb-0">
                  <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item fw-semibold"><meta itemprop="position" content="1">
                    <a itemprop="item" [routerLink]="['/accueil']" role="button" routerLinkActive="router-link-active"><span itemprop="name">Accueil</span></a></li>
                  <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item active" aria-current="page"><meta itemprop="position" content="2"><span itemprop="name">Déconnexion</span></li>
                </ol>
            </nav>
            <div class="row row-cols-md-1 row-cols-sm-1 ">
                <div class="slider-txt py-md-5 py-sm-2">
                    <div class="h-100">
                        <h1 class="heading text-uppercase">
                            SE <span style="color : #BADFFF"> Déconnecter </span>
                        </h1>
                    </div>
                    <div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="sign-out-bloc py-5">
        <div class="bloc-sign-out container">
            <div class="bg-white shadow rounded">
                <div class="row">
                    <div class="col-md-7 ">
                        <div class="form-left h-100 py-5 px-5">
                            <div class="flex justify-center mt-0.5 font-medium text-black">
                                <!-- Redirect countdown -->
                                <ng-container *ngIf="countdown > 0">
                                    <h3> Redirection dans {{countdown | i18nPlural: countdownMapping }}
                                    </h3>
                                </ng-container>

                                <!-- Redirect message -->
                                <ng-container *ngIf="countdown === 0">
                                    <h3>Vous êtes maintenant redirigé !</h3>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5 ">
                        <div class="form-right h-100 bg-primary text-white text-start p-5">
                            En demandant à un Conseiller de créer votre compte <span class="blue-text"><strong>THE DOOR MAN</strong></span>, vous
                            bénéficiez de nombreux services :
                            <div class="clearfix float-content mt-2">
                                <ul>
                                    <li>Informations sauvegardées</li>
                                    <li>Réception des offres par mail</li>
                                    <li>Prise de rendez-vous pour un bien</li>
                                    <li>Enregistrement de vos recherches</li>
                                    <li>Enregistrement de vos biens favoris</li>
                                    <li>Abonnement à la newsletter</li>
                                    <li>Suivi personnalisé</li>
                                </ul>
                                <button [routerLink]="['/amis-tdm/liste']" type="submit" class="btn btn-outlined  px-4 float-end mt-4">
                                    Trouver mon Conseiller</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
